export default "__VITE_ASSET__xwkphw$U__"